import { supabase } from '../lib/supabase';

/**
 * Check if the current user has a verified email address
 * Required for creating brands, families, and models
 */
export async function isUserVerified(): Promise<boolean> {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();
    
    if (error || !user) {
      console.error('Error getting user:', error);
      return false;
    }
    
    // Check if user has confirmed_at timestamp
    // This indicates email verification is complete
    return user.confirmed_at != null;
  } catch (error) {
    console.error('Error checking user verification:', error);
    return false;
  }
}

/**
 * Check if the current user is an admin
 * Admins have additional permissions like deleting/editing brands
 */
export async function isUserAdmin(): Promise<boolean> {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();
    
    if (error || !user) {
      return false;
    }
    
    // Check user metadata for admin role
    const metadata = user.user_metadata || {};
    return metadata.role === 'admin';
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
}

/**
 * Get the current user's ID
 */
export async function getCurrentUserId(): Promise<string | null> {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();
    
    if (error || !user) {
      return null;
    }
    
    return user.id;
  } catch (error) {
    console.error('Error getting user ID:', error);
    return null;
  }
}
